<script>
	import { onMount } from "svelte";
	import { navigate } from "svelte-routing";

	onMount(() => navigate("/maintenance-repair", { replace: true }));
</script>
